import { render, staticRenderFns } from "./choose_city_1.vue?vue&type=template&id=87e9483e&scoped=true&"
import script from "./choose_city_1.vue?vue&type=script&lang=js&"
export * from "./choose_city_1.vue?vue&type=script&lang=js&"
import style0 from "./choose_city_1.vue?vue&type=style&index=0&id=87e9483e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e9483e",
  null
  
)

export default component.exports